<template>
  <CreateEditUserForm :user-id="props.userId" />
</template>

<script setup lang="ts">
const props = defineProps<{
  userId: string
}>()
</script>
